import { render } from "./ChatFrame.vue?vue&type=template&id=f8c78f76"
import script from "./ChatFrame.vue?vue&type=script&lang=js"
export * from "./ChatFrame.vue?vue&type=script&lang=js"

import "./ChatFrame.vue?vue&type=style&index=0&id=f8c78f76&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__